import { v7 as uuidv7 } from 'uuid';

/**
 * Idempotency keys.
 *
 * Every mutation carries one so a retry — ours, the user's double-tap, or a
 * proxy replaying a request — cannot move money twice. v7 is used rather than v4
 * because it is time-ordered, which makes the keys sortable in backend logs when
 * something needs to be traced.
 *
 * The key must stay STABLE across retries of the same logical submission. Do not
 * generate it inside a render or a retry callback; generate it once when the
 * user commits to the action.
 */
export function newIdempotencyKey(): string {
  return uuidv7();
}

const HTTP_METHODS_REQUIRING_KEY = new Set(['POST', 'PUT', 'PATCH', 'DELETE']);

export function isMutation(method: string): boolean {
  return HTTP_METHODS_REQUIRING_KEY.has(method.toUpperCase());
}
